import { useMemo } from 'react';

interface Styles {
  [key: string]: string;
}

/**
 * Returns a string with correct extra class names from the provided style sheet.
 * 
 * @param extraClass - String array of extra class names.
 * @param styles - The style sheet object.
 * @returns string with correct class names for the stylesheet
 * 
 * @example
 * ```tsx
 * const extraClasses = useExtraClasses(["extraClass1", "extraClass2"], styles);
 * ```
 */
export function useExtraClasses(extraClass: string[] | undefined, styles: Styles) {
  const extraClassString = useMemo(() => {
    return extraClass
      ? extraClass.map((item) => styles[item]).join(' ')
      : '';
  }, [extraClass, styles]);

  return extraClassString;
}